// extracted by mini-css-extract-plugin
export default {"bookingEventImg":"booking-image-field_bookingEventImg__KRnQI"};